import { supabase } from '@/lib/supabase'

/**
 * Dev-only convenience: automatically sign in with a configured account so the
 * local preview lands on an authenticated session without a manual login step.
 *
 * Opt-in and only ever runs under `vite dev`:
 *   - Guarded by `import.meta.env.DEV` — `false` (and dead-code-eliminated) in
 *     production builds, so this can never affect a deployed app.
 *   - Requires `VITE_DEV_AUTO_LOGIN=true` plus `VITE_DEV_EMAIL` /
 *     `VITE_DEV_PASSWORD` in `.env.local` (git-ignored). See `.env` for the keys.
 *
 * No-ops when a session already exists, so it never clobbers a real login, and
 * fails silently (falling back to the normal auth screen) if the sign-in errors.
 */
export async function devAutoLogin(): Promise<void> {
  if (!import.meta.env.DEV) return
  if (import.meta.env.VITE_DEV_AUTO_LOGIN !== 'true') return

  const email = import.meta.env.VITE_DEV_EMAIL as string | undefined
  const password = import.meta.env.VITE_DEV_PASSWORD as string | undefined
  if (!email || !password) return

  const { data } = await supabase.auth.getSession()
  if (data.session) return

  await supabase.auth.signInWithPassword({ email, password })
}
